import moment from 'moment'

const states = {
    model_accuracy_details: {
        correct_intents: [],
        table_columns: [],
        source_filters: [],
        selected_source_filters: [],
        selected_date_range: [moment(new Date(), "DD-MM-YYYY").subtract(7, 'days'), moment(new Date(), "DD-MM-YYYY")],
        intents_loading: false,
        intents_load_error: false
    }
}

export default states



// WEBPACK FOOTER //
// ./src/data/redux/model_accuracy_details/states.js